export default "__VITE_ASSET__FBHpQbcM__"